import { Link } from 'react-router-dom'
import { Meteors } from '@stianlarsen/meteors'
import projects from '../../data/projects'
import './ProjectList.css'

const ProjectList = () => {
  return (
    <div className="project-list">
      <div className="project-list__container" style={{ position: 'relative' }}>
        <Meteors
          speed={0.1}
          size={20}
          amount={2}
          colorLightmode="#2978b5"
          colorDarkmode="white"
          fallingSide="left"
        />

        <h2 className="project-list__title">All Projects</h2>
        <p className="project-list__subtitle">
          A collection of products and client work I have shipped.
        </p>

        {/* ── Projects Grid (includes P&L) ── */}
        <div className="project-list__section-label">Projects</div>
        <div className="project-list__grid">
          {projects.map((project) => (
            <Link
              key={project.slug || project.title}
              className="project-list__card"
              to={`/projects/${project.slug}`}
              style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
            >
              <div className="project-list__card-img-wrap">
                <img
                  src={project.featuredImage || project.images?.[0]}
                  alt={project.title}
                  className="project-list__card-img"
                  style={project.slug === 'pnl-app' ? { objectPosition: 'bottom center' } : undefined}
                />
              </div>
              <div className="project-list__card-body">
                <h3 className="project-list__card-title">{project.title}</h3>
                <p className="project-list__card-desc">
                  {project.description.length > 110
                    ? `${project.description.substring(0, 110)}...`
                    : project.description}
                </p>
                <span className="project-list__card-cta">View Details →</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="project-list__back">
          <Link to="/" className="project-list__back-link">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  )
}

export default ProjectList
